import { Component, OnInit, EventEmitter, Input, Output } from "@angular/core";
import { CardModel } from "./card.model";
import { faHeart, faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { KeyValue } from "../../../models/keyvalue.model";
import { BaseHttpService } from "../../../services/basehttp.service";
import { Constants } from "../../../../shared/constants";
import { Router } from "@angular/router";
import { CardService } from "../../../../shared/components/view/card/card.service";
import { ModalSize } from "../../../../shared/components/view/modal/modal.model";
import {
  ButtonSize,
  ButtonStyle,
  ButtonType,
  ButtonColors
} from "../../../../shared/components/inputs/button/button.model";
import { NotificationService } from "../../../../shared/services/notifications.service";
import { DashboardComponent } from "src/app/dashboard/dashboard.component";
import { ParamService } from "../../../../shared/services/param.service";
import { SurveyModel } from 'src/app/dashboard/dashboard.model';
import { UserServiceService } from 'src/app/user/survey-main/service/user-service.service';
import { GroupModel, UserGroupDataModel, UserGroupModel } from 'src/app/admin/models/group.model';
import { GlobalsessionhandlerService } from 'src/app/shared/services/globalsessionhandler.service';
import { forkJoin } from 'rxjs';
import { CreateSurvey } from '../../page/page.model';
import { WorkflowView } from "src/app/create/models/workflowView.model";
import { SurveyResponse, SurveyUserResponse } from 'src/app/create/models/serveyResponses.model';
import { WorkflowStepAssignedView } from "src/app/create/models/workflowStepAssignedView.model";

@Component({
  selector: "app-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.scss"]
,  standalone: false
})
export class CardComponent implements OnInit {
  constant: Constants = new Constants();
  @Input() data: CardModel = new CardModel();
  @Input() conditionalink: string;
  //Will send the Card Id to the Parent to set the card as Favourite. Refresh the card to reflect changes
  @Output() setAsFavourite: EventEmitter<string> = new EventEmitter();
  @Output() emitActionItem: EventEmitter<Object> = new EventEmitter();
  linkList: Array<KeyValue<string, string>> = [];
  faHeart = faHeart;
  faEllipsisH = faEllipsisH;
  modalSize = ModalSize.Small;
  SaveAsModalSize=ModalSize.Medium;
  modalText = "Delete Survey";
  hidePopUp: boolean = true;
  btnText = "CONTINUE";
  btnMedium = ButtonSize.Medium;
  btnWithText = ButtonStyle.Textonly;
  btnRect = ButtonType.Rectangle;
  btnBlue = ButtonColors.Blue;
  btncloseText = "CLOSE";
  deleteSuveyId: string;
  deleteSurveyFromGroupId:string;
  mySurvey:SurveyModel[]=[];
  myTemplates:SurveyModel[]=[];
  selctedSurvey:SurveyModel;
  isAdmin:boolean=false;
  isRespondent:boolean=false;
  isDesigner:boolean=false;
  user: UserGroupModel;
  //multipleResponse: boolean =  true;

  //Save as template
  SaveAsModalText:string="";
  hideSaveAsPopUp:boolean=true;
  lblText:string="";
  placeHolderText:string="";
  templateSurveyId:string="";
  TemplateName:string="";
  btnSaveText:string="SAVE";
  IsNewSurvey:boolean=false;
  //WF
  workflowDetails:WorkflowView=new WorkflowView();
  users:UserGroupModel[]=[];
  groups:GroupModel[]=[];
  conditionalOp=[];
  userInfo: UserGroupDataModel = new UserGroupDataModel();
  existingUsers=[];
  //
  today=Date.now();

  constructor(
    private baseHttpService: BaseHttpService,
    private router: Router,
    private cardservice: CardService,
    private notificationService: NotificationService,
    private dashboard: DashboardComponent,
    private paramservice: ParamService,
    private userService: UserServiceService,
    private sessionHanlder:GlobalsessionhandlerService ) {
    //this.today=this.date.transform(Date.now(),'yyyy-MM-dd');
    this.linkList = [
      { key: "quickView", value: "Take Survey" },
      { key: "ViewResponse", value: "View Response"},
      { key: "TakeActionWF", value: "Take Action"},
      {key:"ViewWF",value:"View Response"},
      { key: "ResumeView", value: "Resume Survey"},
      { key: "ViewCompletedSurvey", value: "View Response(s)"},
      { key: "edit", value: "Edit" },
      { key: "results", value: "Results" },
      { key: "createAsNew", value: "Create As New" },
      { key: "share", value: "Share" },
      { key: "saveAsTemplate", value: "Save As Template" },
      // { key: "analyze", value: "Analyze Survey" },
      { key: "delete", value: "Delete" },
      {key: "removetemplate", value:"Remove Template"},
      { key: "archive", value: "Archive" },
      {key:"restore",value:"Restore"}
    ];
  }

  ngOnInit() {

    this.userService.currentUser.subscribe((message: UserGroupModel) =>
    {
        this.user = message;
        if(this.user.userTypeId=="1")
        {
          this.isAdmin=true;
        }
        if(this.user.userTypeId=="2")
        {
          this.isDesigner=true;
        }
        if(this.user.userTypeId=="3")
        {
          this.isRespondent=true;
        }
    });
  }

  setFavourite(event) {
    this.setAsFavourite.emit(this.data.id); //send the cardId to Parent
  }
  actionLinks(key: string, surveyId: string,status :string,groupId :string) {
    ;
    
    this.sessionHanlder.setSurveyId(surveyId);
    let survey = new CreateSurvey;
    survey.surveyId = surveyId;
    survey.name=this.data.cardTitle;
    survey.status = status;
    survey.isLoginRequired = this.data.isLoginRequired;
    survey.isWorkflow=this.data.IsWorkflow;
    survey.dueDaysCount=this.data.dueDaysCount;
    survey.isOverdueAccessAllowed=this.data.isOverdueAccessAllowed;
    survey.isMultipleResponseAllowed=this.data.isMultipleResponseAllowed;
    survey.isOverdue=this.data.isOverdue;
    survey.dueDate=this.data.dueDate;
    this.sessionHanlder.setSurvey(survey);
    this.sessionHanlder.setSurveyStatus(status);

    if (key == "edit") {
      this.editSurvey(surveyId);
    } else if (key == "delete") {
      this.hidePopUp = false;
      this.deleteSuveyId = surveyId;
      this.deleteSurveyFromGroupId=groupId;
    } else if (key == "quickView") {
      this.quickViewSurvey(surveyId);
    } else if (key == "results") {
      this.surveyResults(surveyId);
    } else if (key == "saveAsTemplate") {
      this.SaveAsTemplate(surveyId,groupId);
    } else if (key == "createAsNew") {
      this.SurveyCreation(surveyId);
    }
    else if(key=='archive')
    {
      this.ArchiveSurvey(surveyId);
    }
    else if(key=='restore')
    {
      this.RestoreSurvey(surveyId);
    }
    else if(key=='removetemplate')
    {
      this.RemoveTemplate(surveyId,groupId);
    }
    else if (key == 'ResumeView') {
      this.ResumeViewSurvey(surveyId,groupId);
    }
    else if (key == 'ViewCompletedSurvey') {
      this.ViewSurveyResult(surveyId,groupId);
     // this.ResumeViewSurvey(surveyId,groupId);;
    }
else if (key == 'ViewWF'||key=='TakeActionWF') {
      this.ViewWFActivity(surveyId,groupId);;
    }else if (key == 'ViewResponse'){
      this.ViewResponse(surveyId, groupId);
    }    // else if(key=='analyze')
    // {
    //   this.sessionHanlder.setSurveyId(surveyId);
    //   this.analyzeSurvey(surveyId);
    // }
     else {
      this.emitActionItem.emit({ surveyId: surveyId, type: key });

    }
  }
  editSurvey(surveyId: string) {
    this.baseHttpService
      .getById(this.constant.getSurveyById, surveyId)
      .subscribe(result => {
        
        if (result != null) {
          this.sessionHanlder.SetESignReq(result["isESignReq"]);
          this.cardservice.getSurveyDetails(result);
          this.loadWfDetails(result);
          // this.paramservice.Parameterpass("CREATE");
          // this.router.navigate(["/create"]);         
        }
      });
  }

  loadWfDetails(surveyDetails:CreateSurvey)
  {
    let selectedOrgId=this.sessionHanlder.getOrganizationId();
    const workflow$ = this.baseHttpService.getById(this.constant.getWorkflow,surveyDetails.surveyId);
    const users$ = this.baseHttpService.getById(this.constant.getAllUsersByOrg,selectedOrgId);
    const groups$ = this.baseHttpService.get(this.constant.getAllGroups);
    const condt$=this.baseHttpService.get(this.constant.getConditioanalOperator);

//    if(surveyDetails.surveyId)
  //  {
      forkJoin([workflow$,users$, groups$,condt$]).subscribe(results => {
        this.workflowDetails=results[0];
        this.conditionalOp=results[3];
        Object.assign(this.groups, results[2]);
        results[2] =  results[2].filter(x=>x.organizationId==selectedOrgId).map(ele => {
          ele.fullName = `${ele.groupName} (G)`;
          return ele;
        });
        this.users = [...results[1], ...results[2]];
        for (const user of this.existingUsers)
        {
          const existingUser = results[1].find(item => item.userId == user.customerId);
           if (existingUser !== undefined) {
            this.userInfo.users.push(existingUser);
          }
          const existingGroup = results[2].find(item => item.groupId == user.customerId);
          if (existingGroup !== undefined) {
            this.userInfo.groups.push(existingGroup);
          }
        }
        this.cardservice.getGroupDetails(this.groups);
        this.cardservice.getUserGroupDetails(this.users);
        this.cardservice.tempHoldWFDetail(this.workflowDetails);
        this.cardservice.getConditionalOpertaors(this.conditionalOp);
        this.paramservice.Parameterpass("CREATE");
        this.router.navigate(["/create"]);
    });
    // }
    // else
    // {
    //   this.paramservice.Parameterpass("CREATE");
    //   this.router.navigate(["/create"]);
    // }

  }


  ViewSurveyResult(surveyId,groupId)
  {
    
    const resp$=this.baseHttpService.getById(this.constant.getSurveyResponses,surveyId+"/true/0/true");
    const reponse$= this.baseHttpService.getById(this.constant.getSurveyById, surveyId);
    forkJoin([reponse$,resp$]).subscribe(results => {
      if (results != null)
      {
        this.cardservice.tempHoldWFDetail(new WorkflowView());
        let tmp:WorkflowStepAssignedView[]=[];
        this.cardservice.tempHoldWFAssignmentDetail(tmp);
        this.cardservice.tempholdSurveyResultData(results[0]);
        this.cardservice.tempHoldResponsedata(results[1])
        this.router.navigate(["/user/view-survey-result"]);
      }
     });
  }

  surveyResults(surveyId: string) {
    
    const resp$=this.baseHttpService.getById(this.constant.getSurveyResponses,surveyId);
    const analytics$ = this.baseHttpService.getById(this.constant.getSurveyAnalysis, surveyId);
    const reponse$= this.baseHttpService.getById(this.constant.getSurveyById, surveyId);
    forkJoin([analytics$,reponse$,resp$]).subscribe(async results => {
      if (results != null) {
        this.cardservice.tempholdSurveyResultData(results[1]);
        this.paramservice.Parameterpass("");
        this.cardservice.tempHoldAnalyticsdata(results[0]);
        this.cardservice.tempHoldResponsedata(results[2])
       // this.paramservice.Parameterpass("ANALYZE");
        this.router.navigate(["/create/results"]);
      }
     });

    // this.baseHttpService
    // .getById(this.constant.getSurveyAnalysis, surveyId)
    // .subscribe(result => {
    //   if (result != null) {
    //    this.cardservice.tempHoldAnalyticsdata(result);
    //     this.paramservice.Parameterpass("ANALYZE");
    //    // this.router.navigate(["/create/analyze"]);
    //   }
    // });

    // this.baseHttpService
    //   .getById(this.constant.getSurveyById, surveyId)
    //   .subscribe(result => {
    //     if (result != null) {
    //       this.cardservice.tempholdSurveyData(result);
    //       this.paramservice.Parameterpass("CREATE");
    //       this.router.navigate(["/create/results"]);
    //     }
    //   });
  }
  quickViewSurvey(surveyId: string) {
    
    const survey$=this.baseHttpService
    .getById(this.constant.getSurveyById, surveyId);
    const wfStep$=this.baseHttpService
    .getById(this.constant.getWfBySurveyId, surveyId);
    const wfStepAccess$=this.baseHttpService
    .getById(this.constant.getWfStepAccessibleBySurveyId, surveyId);
     // this.baseHttpService
    //   .getById(this.constant.getSurveyById, surveyId)
      forkJoin([survey$,wfStep$,wfStepAccess$])
      .subscribe(result => {
        if (result != null) {
          this.cardservice.getSurveyDetails(result[0]);
          this.cardservice.tempHoldWFDetail(result[1]);
          this.cardservice.tempHoldWFAssignmentDetail(result[2]);
          this.router.navigate(["/user/initiate-survey"]);
        }
      });
  }

  ViewWFActivity(surveyId: string,groupId:string)
  {
    
    const survey$=this.baseHttpService
    .getById(this.constant.getSurveyById, surveyId);
    const wfStep$=this.baseHttpService
    .getById(this.constant.getWfBySurveyId, surveyId);
    // const wfStepAccess$=this.baseHttpService
    // .getById(this.constant.getWfStepAccessibleBySurveyId, surveyId);
    const wfStepAccess$=this.baseHttpService
     .getById(this.constant.ViewWFStatus, surveyId);
      forkJoin([survey$,wfStep$,wfStepAccess$])
      .subscribe(result => {
        if (result != null) {
          this.cardservice.getSurveyDetails(result[0]);
          this.cardservice.tempHoldWFDetail(result[1]);
          this.cardservice.tempHoldWfResult(result[2]);
          this.router.navigate(["/user/view-workflow"]);
        }
      });
  }
  ResumeViewSurvey(surveyId: string,groupId:string) {
    
    const survey$= this.baseHttpService.getById(this.constant.getSurveyById, surveyId);
    const surveyResponse$= this.baseHttpService.get(this.constant.getSurveyResponses+"/"+ surveyId+"/"+false);

    forkJoin([survey$,surveyResponse$]).subscribe(results => {
      if (results != null) {
        this.cardservice.getSurveyDetails(results[0]);
        let response=new SurveyUserResponse();
        
        if(results[1]!=null)
        {
        response=results[1].userResponses.filter(x=> x.groupId==groupId && x.isSurveyCompleted==false)[0];
        }
        this.cardservice.getUserResponseSurvey(response);
        this.router.navigate(["/user/start-survey"]);
      }
      });
  }

  GetTemplateData(surveyId,name)
  {
    
    let tempName=name.length>0?name:this.selctedSurvey.name;
    let tempSurvey=new CreateSurvey();
    tempSurvey.name=tempName;
    tempSurvey.surveyId=surveyId;;
    tempSurvey.surveyGroupId=this.selctedSurvey.surveyGroupId;
    if(this.myTemplates.filter(x=>x.name.toUpperCase()==tempName.toUpperCase() && x.surveyGroupId==this.selctedSurvey.surveyGroupId).map(x=>x).length>0)
    {
      this.notificationService.showError("Unable to create a template as template name already exist for the group: " + this.selctedSurvey.surveyGroupName +", Please enter new template name to save.", "Template Creation Failed!");
      this.hideSaveAsPopUp=false;
      this.TemplateName=tempName;
      this.SaveAsModalText="Save As Template";
      this.lblText="Template Name";
      this.placeHolderText="Enter Template Name";
    }
   else
   {
    
    this.hideSaveAsPopUp=true;
    this.baseHttpService

    .post(this.constant.craetetemplate, tempSurvey)
     // .post(this.constant.craetetemplate + "/" + surveyId+"/"+tempName, null)
      .subscribe(result => {
        this.notificationService.showSuccess(
          "You have successfully created the new template.",
          "Survey saved as Template Successful!"
        );
        // this.baseHttpService.get(this.constant.getTemplateData).subscribe(result=>{
        //   this.myTemplates=result;
        //   this.cardservice.getUserTemplate(result);
        //   });
        //this.dashboard.getDashboardSurveys();
      });
    }
  }

  SaveAsTemplate(surveyId: string,groupId:string,name:string="") {
    //   
    this.IsNewSurvey=false;
    this.templateSurveyId=surveyId;
    this.cardservice.currentUserSurvey.subscribe((message: SurveyModel[]) => this.mySurvey = message);
    //this.cardservice.currentUserTemplate.subscribe((message: SurveyModel[]) => this.myTemplates = message);
    this.selctedSurvey=this.mySurvey.filter(x=>x.surveyId==surveyId && x.surveyGroupId==groupId).map(x=>x)[0];
           this.baseHttpService.get(this.constant.getTemplateData).subscribe(result=>{
           this.myTemplates=result;
           this.cardservice.getUserTemplate(result);
           this.GetTemplateData(surveyId,name);
           });   
   
  }  

  SurveyCreation(surveyId: string,name="") {
    this.hideSaveAsPopUp=true;
   // 
    this.IsNewSurvey=true;
    this.templateSurveyId=surveyId;
    this.cardservice.currentUserSurvey.subscribe((message: SurveyModel[]) => this.mySurvey = message);
    this.cardservice.currentUserTemplate.subscribe((message: SurveyModel[]) => this.myTemplates = message);
    this.selctedSurvey=this.myTemplates.filter(x=>x.surveyId==surveyId).map(x=>x)[0];
    let tempName=name.length>0?name:this.selctedSurvey.name;
    let tempSurvey=new CreateSurvey();
    tempSurvey.name=tempName;
    tempSurvey.surveyId=surveyId;;
    if(this.mySurvey.filter(x=>x.name.toUpperCase()==tempName.toUpperCase() && x.surveyGroupId==this.selctedSurvey.surveyGroupId).map(x=>x).length>0)
    {
      this.notificationService.showError("Unable to create a survey as survey name already exist for the group: " + this.selctedSurvey.surveyGroupName +", Please enter new survey name to proceed.", "Survey Creation Failed!");
      this.hideSaveAsPopUp=false;
      this.TemplateName=tempName;
      this.SaveAsModalText="Create As New";
      this.lblText="Survey Name";
      this.placeHolderText="Enter Survey Name";
    }
   else
   {

    this.hideSaveAsPopUp=true;
    this.baseHttpService
      .post(this.constant.copySurvey , tempSurvey)
      .subscribe(result => {
        this.notificationService.showSuccess(
          "You have successfully created the new survey.",
          "Survey Successful!"
        );
        //this.dashboard.getDashboardSurveys();
      });
    }
  }

  close(event) {
    this.hidePopUp = true;
    this.hideSaveAsPopUp=true;
  }
  DeleteSrvey() {
  //  
    this.baseHttpService
      .deleteApi(this.constant.getSurveyById+"/"+this.deleteSuveyId+"/"+this.deleteSurveyFromGroupId)
      .subscribe(result => {
        this.hidePopUp = true;
        this.notificationService.showSuccess(
          "You have successfully deleted the survey.",
          "Survey Deleted!"
        );
        this.dashboard.getDashboardSurveys();
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/']);
      });

        //this.dashboard.getDashboardSurveys();
      });
  }

  ArchiveSurvey(surveyId:string)
  {
    this.baseHttpService
    .post(this.constant.archiveSurvey+ "/" + surveyId, null)
    .subscribe(result => {
      this.notificationService.showSuccess(
        "You have successfully archived the survey.",
        "Survey Archived!"
      );
      this.dashboard.getDashboardSurveys();
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/']);
    });
      //this.dashboard.getDashboardSurveys();
    });
  }

  RestoreSurvey(surveyId:string)
  {
    this.baseHttpService
    .post(this.constant.restoreSurvey+ "/" + surveyId, null)
    .subscribe(result => {
      this.notificationService.showSuccess(
        "You have successfully restored the survey.",
        "Survey Restored!"
      );
      this.dashboard.getDashboardSurveys();

      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/']);
     });
      //this.dashboard.getDashboardSurveys();
    });
  }

  RemoveTemplate(surveyId:string,groupId: string)
  {
    
    let removeFromTempaltes = true;
    this.baseHttpService
    .deleteApi(this.constant.getSurveyById+"/"+surveyId+"/"+groupId + "/" + removeFromTempaltes)
    .subscribe(result => {
      this.notificationService.showSuccess(
        "You have successfully removed the template.",
        "Template Removed!"
      );
      this.dashboard.getDashboardSurveys();
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/dashboard/templates']);
    });

     // this.dashboard.getDashboardSurveys();
    });
  }
  ViewResponse(surveyId: string,groupId:string) {
    
    const survey$= this.baseHttpService.getById(this.constant.getSurveyById, surveyId);
    const surveyResponse$= this.baseHttpService.get(this.constant.getSurveyResponses+"/"+ surveyId);

    forkJoin([survey$,surveyResponse$]).subscribe(results => {
      if (results != null) {
        this.cardservice.getSurveyDetails(results[0]);
        let response=new SurveyUserResponse();
        
        if(results[1]!=null)
        {
        response=results[1].userResponses.filter(x=> x.groupId==groupId && x.isSurveyCompleted==true)[0];
        }
        this.cardservice.getUserRespIsReadonly(true);
        this.cardservice.getUserResponseSurvey(response);
        this.router.navigate(["/user/start-survey"]);
      }
      });
  }

}
